import qs from 'qs';
import axios from 'axios';

import {
    METHOD_POST,
    CONTENT_TYPE_FORM,
    XML_HTTP_REQUEST_HEADER,
    getUserFormSubmitTokenHeader,
    catchSplajaxError,
} from '../utils';

let rootDomain = '';
let csrfToken = '';

export const setRootDomain = (domain) => {
    rootDomain = domain;
};

export const setCsrfToken = (token) => {
    csrfToken = token;
};

/**
 *
 * @param {string} url
 * @param {boolean} appendToParams - Indicates if a '?' should be used for the querystring
 *
 * @return {string}
 */
function buildAppUrl(url) {
    const appendToParams = url.indexOf('?') !== -1;

    return `https://${rootDomain}${url}${appendToParams ? '&' : '?'}csrfToken=${csrfToken}`;
}

// Only works for org admins
const exportEventsToEmail = (fileName, paramString) =>
    axios({
        url: `/address_book/event_api_search?${paramString}`,
        headers: {
            ...XML_HTTP_REQUEST_HEADER,
            ...getUserFormSubmitTokenHeader(),
        },
    })
        .then((response) => response.data)
        .then((response) => {
            if (typeof response === 'string') {
                return response;
            } else {
                throw new Error('Error exporting to email');
            }
        });

export const exportEvents = (fileName, options = {}) => {
    const params = qs.stringify({
        outfile: fileName,
        export_data: true,
        ...options,
    });

    if (options.exportToEmail) {
        return exportEventsToEmail(fileName, params);
    }

    const url = `/address_book/event_api_search?${params}`;
    try {
        window.location.href = url;
    } catch (err) {
        return Promise.reject(new Error(`Error redirecting to ${url}`));
    }

    return Promise.resolve({ url: buildAppUrl(url) });
};

export const getDeletedTicketTypesWithZeroPurchase = (eventId) =>
    axios({
        url: `/admin/getDeletedTicketTypesWithZeroPurchase/${eventId}`,
        withCredentials: true,
    })
        .then((response) => response.data)
        .catch(catchSplajaxError);

export const removeDeletedTicketTypesWithZeroPurchase = (eventId, deletedTicketTypeIds) =>
    axios({
        url: '/admin/removeDeletedTicketTypesWithZeroPurchase',
        ...METHOD_POST,
        withCredentials: true,
        headers: { ...CONTENT_TYPE_FORM },
        data: qs.stringify({ eventId, deletedTicketTypeIds }),
    })
        .then((response) => response.data)
        .catch(catchSplajaxError);

export const removeEventFromHub = (eventId, hubId) =>
    axios({
        url: buildAppUrl('/events/deleteEventFromHub'),
        ...METHOD_POST,
        withCredentials: true,
        headers: { ...CONTENT_TYPE_FORM },
        data: qs.stringify({
            event_ids: [eventId],
            splash_hub_id: hubId,
        }),
    })
        .then((response) => response.data)
        .catch(catchSplajaxError);

export const sendCollaboratorInvite = (eventId, collaboratorId) =>
    axios({
        url: '/events/sendEventInvite',
        ...METHOD_POST,
        withCredentials: true,
        headers: { ...CONTENT_TYPE_FORM },
        data: qs.stringify({ event_id: eventId, id: collaboratorId }),
    });

export const getPostEventSurveys = (eventId) =>
    axios({
        url: buildAppUrl(`/events/getSurveyStatus/${eventId}`),
        withCredentials: true,
    }).then(({ data }) => data);

export const editGuestData = (updatedData) =>
    axios({
        url: '/events/editGuests',
        ...METHOD_POST,
        withCredentials: true,
        headers: { ...CONTENT_TYPE_FORM },
        data: qs.stringify(updatedData),
    });

export const syncWithSalesforce = (eventId, action) =>
    axios({
        url: '/events/salesforceSync',
        ...METHOD_POST,
        withCredentials: true,
        data: qs.stringify({ event_id: eventId, action }),
    });

export const validateEmailForShareGuestList = (email, eventId) =>
    axios({
        url: `/events/${eventId}/share-guest-list`,
        ...METHOD_POST,
        withCredentials: true,
        data: qs.stringify({
            email,
        }),
    }).then((response) => response.data);

export const getGuestlistBootstrapData = (eventId) =>
    axios({
        url: `/events/getAttendeeTabBootstrapData/${eventId}`,
        withCredentials: true,
    });
